import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { UIShowAlert } from '../../../../actions/ui';
import SendMessage from '../../../common/forms/SendMessage';
import { sendBulkMessageAction, startConversation } from '../../../../actions/conversations';
import Close from '../../../common/ui/Close';
import UsersService from '../../../../services/UsersService';
import QuickView from '../../../common/ui/QuickView/QuickView';
import ChatBackArrow from '../../../common/ui/QuickView/ChatBackArrow';
import ConversationContainer from '../../messages/ConversationContainer';
import { conversationTypes } from '../../../../constants/conversations';

class MessageHiredWorkers extends Component {
  static propTypes = {
    jobDetails: PropTypes.object,
    eventId: PropTypes.number,
    hiredWorkers: PropTypes.array.isRequired,
    sendBulkMessageAction: PropTypes.func.isRequired,
    startConversation: PropTypes.func.isRequired,
    UIShowAlert: PropTypes.func.isRequired,
    updateConversationMessagesCount: PropTypes.func.isRequired
  };

  static defaultProps = {
    jobDetails: {}
  };

  state = {
    messageModalIsShown: false,
    isMessageSending: false,
    isGroupChatQuickViewOpened: false
  };

  showMessageForm = () => {
    if (UsersService.isAdmin()) {
      this.setState({ messageModalIsShown: true });
    } else {
      this.openGroupChat(); // for employer
    }
  };

  hideMessageForm = () => this.setState({ messageModalIsShown: false, isMessageSending: false });

  mapHiredWorkersIds = () => {
    return this.props.hiredWorkers.map(job_worker => job_worker.user_id);
  };

  bulkMessageHiredWorkers = formData => {
    const { sendBulkMessageAction, UIShowAlert } = this.props;
    this.setState({ isMessageSending: true });

    const userIds = this.mapHiredWorkersIds();

    return sendBulkMessageAction({ ...formData, userIds })
      .then(data => {
        if (data) {
          UIShowAlert('Your message has been sent!');
          this.hideMessageForm();
        }
      })
      .catch(error => {
        UIShowAlert(error);
        this.hideMessageForm();
      });
  };

  openGroupChat = () => {
    const { jobDetails } = this.props;
    const participants = this.mapHiredWorkersIds();
    participants.push(jobDetails.user_id);
    if (!jobDetails.conversation_id) {
      this.props.startConversation({
        type: conversationTypes.job,
        users: participants,
        job_id: this.props.jobDetails.id
      });
    }
    this.openGroupChatQuickView();
  };

  openGroupChatQuickView = () => this.setState({ isGroupChatQuickViewOpened: true });

  closeGroupChatQuickView = () => this.setState({ isGroupChatQuickViewOpened: false });

  render () {
    const { messageModalIsShown, isMessageSending, isGroupChatQuickViewOpened } = this.state;
    const { eventId, jobDetails, updateConversationMessagesCount } = this.props;

    return (
      <Fragment>
        <button className='button button-primary' onClick={this.showMessageForm}>
          Message Hired Workers
        </button>
        { UsersService.isAdmin() ? (
          <Modal isOpen={messageModalIsShown} centered>
            <div className='modal-header'>
              <div className='modal-title'>{ jobDetails.id ? `Job ${jobDetails.id}` : `Event ${eventId}`}</div>
              <Close onClick={this.hideMessageForm} />
            </div>
            <div className='modal-body'>
              <SendMessage
                onSubmit={this.bulkMessageHiredWorkers}
                onCancel={this.hideMessageForm}
                isLoading={isMessageSending}
              />
            </div>
          </Modal>
        ) : (
          <Fragment>
            { isGroupChatQuickViewOpened && (
              <div className='group-chat-quick-view'>
                <QuickView
                  isActive
                  isLoading={!jobDetails.conversation_id}
                  onClose={this.closeGroupChatQuickView}
                  closeButtonComponent={<ChatBackArrow onClick={this.closeGroupChatQuickView} />}
                >
                  <ConversationContainer
                    conversationId={jobDetails.conversation_id}
                    updateConversationMessagesCount={updateConversationMessagesCount}
                  />
                </QuickView>
              </div>
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  sendBulkMessageAction,
  startConversation,
  UIShowAlert
};

export default connect(null, mapDispatchToProps)(MessageHiredWorkers);



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/WorkersTab/MessageHiredWorkers.js